import React from 'react';
import { Copy, AlertTriangle } from 'lucide-react';
import alertService from '../../utils/alert';

const label = (k) => k.replace(/([A-Z])/g, ' $1').replace(/^./, (c) => c.toUpperCase());
const copy = async (text) => {
  try { await navigator.clipboard.writeText(typeof text === 'string' ? text : JSON.stringify(text, null, 2)); alertService.toast?.('success', 'Copied'); } catch { /* clipboard unavailable */ }
};

function Value({ v }) {
  if (v === null || v === undefined || v === '') return <span className="text-[#9a9a9a] text-[12px]">—</span>;
  if (typeof v === 'string') {
    return (
      <div className="group relative">
        <p className="text-[13px] text-[#2E2E2E] whitespace-pre-wrap pr-8">{v}</p>
        <button type="button" aria-label="Copy" onClick={() => copy(v)} className="absolute top-0 right-0 text-[#706E6B] hover:text-[#0176D3]"><Copy size={14} /></button>
      </div>
    );
  }
  if (typeof v === 'number' || typeof v === 'boolean') return <span className="text-[13px]">{String(v)}</span>;
  if (Array.isArray(v)) {
    if (!v.length) return <span className="text-[#9a9a9a] text-[12px]">None</span>;
    return <div className="space-y-2">{v.map((x, i) => <div key={i} className="border border-[#E5E5E5] rounded p-2 bg-[#FAFAFA]"><Value v={x} /></div>)}</div>;
  }
  return (
    <dl className="space-y-1">
      {Object.entries(v).map(([k, x]) => (
        <div key={k}><dt className="text-[11px] font-semibold uppercase text-[#706E6B]">{label(k)}</dt><dd><Value v={x} /></dd></div>
      ))}
    </dl>
  );
}

// Output preview. Warnings and missing information come first: the user must see limits before using text.
export default function ResultView({ output }) {
  if (!output) return null;
  const { warnings = [], missingInformation = [], ...rest } = output;
  return (
    <div className="space-y-4">
      {(warnings.length > 0 || missingInformation.length > 0) && (
        <div className="rounded border border-[#F6D58A] bg-[#FFF8E6] p-3 text-[12px] text-[#7A5A00] space-y-1">
          {warnings.map((w, i) => <p key={`w${i}`} className="flex gap-2"><AlertTriangle size={14} className="shrink-0 mt-0.5" />{w}</p>)}
          {missingInformation.map((w, i) => <p key={`m${i}`} className="flex gap-2"><AlertTriangle size={14} className="shrink-0 mt-0.5" />Missing: {w}</p>)}
        </div>
      )}
      {Object.entries(rest).map(([k, v]) => (
        <section key={k}>
          <h4 className="text-[11px] font-bold uppercase tracking-wide text-[#706E6B] mb-1">{label(k)}</h4>
          <Value v={v} />
        </section>
      ))}
    </div>
  );
}
